module.exports = __webpack_public_path__ + "img/arrow-down-01.7b5c43cf.svg";